export default "__VITE_ASSET__5c3b7828__"